<div *ngIf="district == ''" class="tileHeading">{{title}}</div>
<table *ngIf="turnout" class="table-container">
  <tr>
    <td class="text"> Electors enrolled </td>
    <td class="numbers">
      {{turnout.electorsEnrolled |number}}
    </td>
  </tr>

  <ng-container *ngIf="isFinal">
    <tr>
      <td class="text"> Votes cast </td>
      <td class="numbers">
        {{turnout.votesCast |number}}
      </td>
    </tr>
  </ng-container>
  <ng-container *ngIf="!isFinal">
    <tr *ngIf="turnout.isProvisional == true">
      <td class="text"> Votes counted </td>
      <td class="numbers">
        {{turnout.votesCounted |number}}
      </td>
    </tr>
  </ng-container>

  <tr>
    <td class="text"> Formal votes </td>
    <td class="numbers">
      {{turnout.formalVotes |number}}
    </td>
    <td class="percent"> ({{turnout.formalPercent/100|percent :'1.1-1'}}) </td>
  </tr>
  <tr>
    <td class="text"> Informal votes </td>
    <td class="numbers">
      {{turnout.informalVotes |number}}
    </td>
    <td class="percent"> ({{turnout.informalPercent/100 |percent :'1.1-1'}}) </td>
  </tr>

  <ng-container *ngIf="isFinal">
    <tr>
      <td class="text">
        {{isFinal===true ? 'Turnout' : 'Count percent'}}
      </td>
      <td class="numbers">
        {{turnout.turnoutPercent/100 |percent :'1.1-1'}}
      </td>
    </tr>
  </ng-container>
  
</table>
